import React from 'react';

import './style.css';

const AboutDetails = (props) => {
  return (
    <div className="wpo-about-area section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 colsm-12">
            <div className="wpo-about-text">
              <h2 className="pb-4">Our Focus</h2>
              <p>
                LCHF’s focus is to create a World where children are in schools
                not on the streets.
              </p>

              <p>
                In addition, to provide an opportunity for all, where vulnerable
                families are out of poverty to a future full of Hope, and where
                there is, no child left behind.
              </p>

              <h2 className="pb-4">Our Projects</h2>
              <p>
                Through Education, Healthcare, Business Creation, Talent
                Development, Affordable Housing Support, Counseling and Psycho-therapy. LHCF supports Programs that
                helps bring life changing care, love and hope to all the
                orphans, street children, and vulnerable families.
              </p>

              <h2 className="pb-2">Our Journey</h2>

              <img
                src="https://lhcf-general-storage.s3.ca-central-1.amazonaws.com/lhcf-ceo-rose.jpg"
                alt="LHCF CEO - Rose UMUTONI"
              ></img>

              <p>Rose UMUTONI</p>

              <h4 className="pb-4">Message from the President and Founder</h4>
              <p>
                Love Hope and Care Foundation was registered on October 23 rd of
                2019 and it’s Headquarters is in Vancouver, Canada. The
                foundation is based on my own personal childhood experiences,
                and it honors the promise I made to God; to serve him in all
                ways by providing unconditional love, restoring their hope and
                giving care to vulnerable children and families.
              </p>

              <i>
                “In the same way, let your light shine before others, so that
                they may see your good works and give glory to your Father who
                is in heaven” - Matthew 5:16
              </i>

              <h5 className="pb-3 mt-5">Our Address</h5>

              <p>HEAD OFFICE: Vancouver, Canada.</p>
              <p>LHCF Office/Centre in Rwanda: KG436 Kagugu Kigali, Rwanda.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutDetails;
